import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { zip } from 'rxjs';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent {

  title: string;
  message: string;
  confirmText: string;
  cancelText: string;

  /** Nazwa obiektu, którego dotyczy pytanie; doklejana do tytułu osobno, żeby sam tytuł został interpolacją. */
  titleName: string;

  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, public translate: TranslateService) {
    this.titleName = data.titleName;

    zip(
      this.translate.get(data.title || 'confirmation'),
      this.translate.get(data.message || 'areYouSure', data.messageParams),
      this.translate.get(data.confirmText || 'yes'),
      this.translate.get(data.cancelText || 'cancel')
    ).subscribe(
      ([title, message, confirmation, cancel]: [string, string, string, string]) => {
        this.title = title;
        this.message = message;
        this.confirmText = confirmation;
        this.cancelText = cancel;
      }
    );
  }

}
